import FormInputTypes from "../components/atoms/formEnums/formInputTypes";
import tableAppBlackoutsContent from "./tableAppBlackoutsContent";

export default {
  title: 'Blackout Content',
  attributeName: 'appBlackoutContent',
  fields: [
    {
      attributeName: 'emptymessage',
      type: FormInputTypes.TEXT,
      label: 'You can create blackouts only in edition, so save the information and go back to this content',
      default: "",
      visibleWhenCreate:true,
      visibleWhenEdit:false

    },
    {
      attributeName: 'blackoutContentTable',
      type: FormInputTypes.TABLECOMPONENT,
      mode:'POPUP',
      helpText: '',
      configFile: tableAppBlackoutsContent,
      visibleWhenCreate:false,
      visibleWhenEdit:true
    },

  ],
};
